import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'VaR',
    key: 'var',
    order: 184,
    columnLables: {
      var_value: {
        name: 'VAR Value *',
        order: 302
      },
      var_calculation_method: {
        name: 'VAR Calculation Method Code Type *',
        order: 146
      },
      risk_measure_description: {
        name: 'Risk measure description',
        order: 147
      }
    }
  }
];

export function Var({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.VAR_RISK_MEASURE,
    onChangeFund,
    schema: schema.VAR_RISK_MEASURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.VAR_RISK_MEASURE?.field_names || [],
    tableName: 'VAR_RISK_MEASURE',
    isMultiFunds,
    funds,
    tables: _tables,
    isSingleData: true
  });

  return (
    <StyledTables id="reporttables-var-group">
      {tables.map((rows, index) => (
        <Table
          key={index + 'VALUE_FOR_YEARS_RISK_MEASURE'}
          id={`reporttables-var-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        />
      ))}
    </StyledTables>
  );
}
